Controller = App.loadClass 'core::Angular/Controller'
Handler = new (App.loadClass 'core::Handler')

class exports.FinishController extends Controller

    constructor: (@scope, @transitions, @fields, @pgis, @zones, @state, @timeout, @validation) ->
        if @validation.canContinue()
            @scope.field_data = @validation.getFieldData()
            @validation.setHideNext(true)
            @validation.setHideBack(true)

            @initialize()

    initialize: () =>
        @initializeValidation()
        @initializeVariables()
        @initializeWatchers()
        @save()

    geojsonToWkt: (geojson) =>
        return @pgis.geojsonToWkt(geojson).then (response) =>
            # get geom
            geometry = response.data.data
            # set it on field data
            @scope.field_data.geom = geometry

            return @scope.field_data

    saveField: (field) =>
        # we update via saveGeometry
        method = 'saveGeometry'
        return @fields[method](field, @validation.api_data_token, @fields.getYear()).then (response) =>
            # make sure we were able to save the field
            if response.data.status.type is 'success'
                # get fields_id
                fields_id = response.data.data.id
                # update message
                @message 'Checking for zones...'

                return fields_id
            else
                return response.data.status.msg

    saveZone: (zone, type) =>
        # save the zone and all areas
        @scope.save_zones.save(zone).then (response) =>
            # ensure we saved the zone successfully
            if response.data.status.type is 'success'
                # update message
                @message "Finished saving #{type} zone"
            else
                @message "Failed to save #{type} zone"

    formatZoneDataForSave: (fields_id, zone, areas) =>
        return {
            id: if zone?.id? then zone.id else false
            fields_id: fields_id
            map_data_categories_id: zone.map_data_categories_id
            zones: areas
            details: if zone.details? then zone.details else false
            extra_info: zone.extra_info
            year: @fields.getYear()
            zone_type: zone.zone_type
        }

    formatZoneAreaDataForSave: (zones) =>
        result = []
        # iterate zone areas and format data
        for zone_area in zones
            # ensure that we have geojson
            if not zone_area.geojson?
                zone_area.geojson = L.GeoUtil.multiPolygonize zone_area.visible.toGeoJSON()
            # push formatted data into the results array
            result.push {
                area: turf.area(zone_area.geojson),
                value: zone_area.value,
                geojson: zone_area.geojson
            }

        return result

    checkForZonesToSave: (fields_id) =>
        # iterate zones (zones array always exists, even if empty)
        for type, zone of @scope.field_data.zones
            # if there are any areas for this zone type, we need to format the data for them
            if zone?.zones?.length > 0
                # update frontend message
                @message "Saving #{type} zone"
                # format data for each zone area
                areas = @formatZoneAreaDataForSave(zone.zones)
                # format final object (for the entire zone + areas)
                formatted = @formatZoneDataForSave(fields_id, zone, areas)
                #  save the zone
                @saveZone(formatted, type).then () =>
                    @scope.count -= 1
            else
                # count another zone as finished since they didn't create a zone for this type
                @scope.count -= 1

    save: () =>
        # convert geojson to wkt for saving
        @geojsonToWkt(@scope.geometry).then (save_field_object) =>
            # set area on the field object
            save_field_object.area = @calculateArea(save_field_object.boundary)

            # Ensure that we have geometry before attempting to save
            if save_field_object.geom?
                # save the field
                @saveField(save_field_object).then (result) =>
                    # if we dont get an id then something went wrong
                    if $.isNumeric(result)
                        @scope.fields_id = result
                        # check for and save zones
                        @checkForZonesToSave(result)
                    else
                        # handle failed status for deleted field case
                        # https://www.pivotaltracker.com/story/show/116171945
                        @scope.error_message = result
                        @scope.count = -1
            else
                # trigger failed status
                @scope.error_message = 'Failed to save field geometry.'
                @scope.count = -1

    getGeometry: () =>
        return if @scope?.field_data?.boundary?.features? then @scope.field_data.boundary.features[0] else @makeBoundaryFeature()

    calculateArea: (geometry) =>
        # find and convert area to acres (by hardcoding a constant? ew.)
        return (turf.area(geometry) * 0.000247105).toFixed(2)

    makeBoundaryFeature: () =>
        return { type: 'Feature', properties: {}, geometry: @scope.field_data.boundary.geometry }

    initializeWatchers: () =>
        # watch count to handle async saving
        @scope.$watch 'count', () =>
            if @scope.count is 0
                @scope.message = 'Finished saving all data!'
                # enable next/done button
                @validation.validate()

            if @scope.count is -1
                @scope.message = @scope.error_message
                # display the message briefly before exiting
                @timeout () =>
                    @validation.validate()
                , 2000

    initializeVariables: () =>
        # initialize message
        @message 'Saving field...'
        # remove boundary layer
        @removeBoundaryLayer()
        # set count
        @scope.count = 3
        # set geometry
        @scope.geometry = @getGeometry()
        # set zones object
        @scope.save_zones = @zones

    initializeValidation: () =>
        @scope.validation = @validation
        @scope.validate = @validate
        @scope.validation.setStepScope(@scope, false)
        @scope.validation.setText('next', 'Done')
        @scope.validation.setDisabled('required', true)
        @scope.validation.setDisabled('next', true)

    cleanup: () =>
        delete @scope.field_data


    validate: () =>
        for zone_area in @scope.field_data.zones
            zone_area.visible.clearLayers?()

        @finish()

    finish: () =>
        switch @scope.field_data.process_mode
            when 'irrigation-add'
                @state.go "grower.#{@scope.validation.settings.redirectState}.step",
                    id: @scope.validation.settings.redirectId
                    step: @scope.validation.settings.step
            when 'zone-add'
                # redirect to wherever we came from
                if @scope.validation.settings.from_data
                    @state.go 'grower.data.view',
                        year: @fields.getYear(),
                        field_id: @scope.field_data.id
                else
                    @state.go "grower.#{@scope.validation.settings.redirectState}.step",
                        id: @scope.validation.settings.redirectId
                        step: @scope.validation.settings.step

            when 'zone-edit', 'add-crop'
                if @scope.validation.settings.from_data
                    @state.go 'grower.data.view',
                        year: @fields.getYear(),
                        field_id: @scope.field_data.id
                else
                    @state.go "grower.#{@scope.validation.settings.redirectState}.step",
                        id: @scope.validation.settings.redirectId
                        step: @scope.validation.settings.step

            else @state.go 'grower.fields'

        @validation.setModeSettings({ process_mode: 'zone-add' })
        @validation.clearLayers()

    removeBoundaryLayer: () =>
        # if we have a field id, ensure that we clear layer store
        if @scope.field_data?.id?
            @pgis.deleteFromLayerStore(@scope.field_data.id)
            @pgis.clearBoundaryLayer()

    message: (msg) =>
        @scope.message = msg
